import React from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@material-ui/core";

import CloseIcon from "@material-ui/icons/Close";
import ReportProblemOutlinedIcon from "@material-ui/icons/ReportProblemOutlined";

import useStyle from "./styles";
import globalUseStyles from "../../../styles";

const DialogConfirmacao = (props) => {
  const {open, onClose, tituloSubtitulo, onConfirmar} = props;

  const classes = useStyle();
  const globalClasses = globalUseStyles();

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>
        <Typography Typography paragraph className={globalClasses.tituloDialog}>
          {tituloSubtitulo?.titulo}
        </Typography>
        <IconButton
          className={globalClasses.closeButtonDialog}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Grid className={classes.confirmacaoAcao}>
          <Grid>
            <ReportProblemOutlinedIcon style={{ color: "yellow" }} />
          </Grid>
          <Grid>
            <Typography
              variant="h6"
              style={{
                textAlign: "center",
              }}
            >
              {tituloSubtitulo.mensagem}
              <br />
              {tituloSubtitulo.subMensagem}
            </Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions style={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" onClick={onConfirmar}>
          Confirmar
        </Button>
        <Button
          variant="outlined"
          color="primary"
          onClick={onClose}
        >
          Cancelar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DialogConfirmacao;
